import { i18n } from "translate/i18n";

export const points = i18n.t("messages.challenge.points").toLowerCase();
export const point = i18n.t("messages.challenge.point").toLowerCase();
